export default "__VITE_ASSET__uw9sdjiP__"